// src/features/designerDetailsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const designerDetailsSlice = createSlice({
  name: 'designerDetails',
  initialState: {
    list: [],
    status: 'idle',
    error: null
  },
  reducers: {
    setDesignerDetails: (state, action) => {
      console.log('Setting designer data in slice:', action.payload);
      state.list = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    clearDesignerDetails: (state) => {
      state.list = [];
      state.status = 'idle';
      state.error = null;
    }
  }
});

export const { setDesignerDetails, setError, clearDesignerDetails } = designerDetailsSlice.actions;


export default designerDetailsSlice.reducer;